import { useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { device } from 'src/constants/mediaQueries';
import useTranslation from 'src/hooks/useTranslation';
import { useTenant } from 'src/providers/Tenant';
import { GA, GTMDataPurchase } from 'src/services/gtag';
import { DesktopCheckoutConfirmation } from './Desktop/DesktopCheckoutConfirmation';
import { MobileCheckoutConfirmation } from './Mobile/MobileCheckoutConfirmation';

export interface CheckoutConfirmationProps {
  confirmationNo: string | undefined; // undefined is when the order has not yet been placed
  isOrderPOR: boolean;
  gtmData: GTMDataPurchase;
  confirmationTitle?: string;
  confirmationParagraph1?: string;
  confirmationParagraph2?: string;
}

export default function Confirmation({ gtmData, ...rest }: CheckoutConfirmationProps) {
  const tenant = useTenant();
  useEffect(() => {
    GA.Ecommerce.purchaseOrder(tenant, gtmData);
  }, [gtmData, tenant]);

  const customText = {
    confirmationTitle: useTranslation('vtaas-ui:checkout:confirmationTitle', 'confirmation.title'),
    confirmationParagraph1: useTranslation('vtaas-ui:checkout:confirmationParagraph1', 'confirmation.body').replace(
      /\^confirmationNo\^/g,
      rest.confirmationNo ?? /* istanbul ignore next */ ''
    ),
    confirmationParagraph2: useTranslation('vtaas-ui:checkout:confirmationParagraph2', 'confirmation.cta'),
  };

  const isMobile = useMediaQuery(device.mobileOrTablet);
  return isMobile ? (
    /* istanbul ignore next */
    <MobileCheckoutConfirmation {...rest} {...customText} />
  ) : (
    <DesktopCheckoutConfirmation {...rest} {...customText} />
  );
}
